<template>
  <div class="animated fadeIn">
    <b-card size="sm" footer-bg-variant="white" footer-border-variant="white">
      <div slot="header"><i class="icon-note"></i> Detail Pengajuan Kasbon</div>

      <b-card-body>
        <b-form
          id="employeeAdvanceForm"
          validated
          novalidate
          @submit="editEmployee"
        >
          <div v-if="loading == false">
            <b-row>
              <b-col sm="4">
                <b-form-group label-for="title" label="Title">
                  <b-form-input
                    id="title"
                    type="text"
                    v-model="$v.employeeAdvanceForm.title.$model"
                    :state="!$v.employeeAdvanceForm.title.$invalid"
                    required
                    placeholder="Title"
                  ></b-form-input>
                  <b-form-invalid-feedback
                    >Title harus di isi.</b-form-invalid-feedback
                  >
                </b-form-group>
              </b-col>
              <b-col sm="4">
                <b-form-group label-for="advance_type" label="Tipe Kasbon">
                  <model-select
                    id="advance_type"
                    :options="listEmployeeAdvanceType"
                    v-model="$v.employeeAdvanceForm.advance_type.$model"
                    :isError="$v.employeeAdvanceForm.advance_type.$invalid"
                    placeholder="-- Harap pilih salah satu --"
                  ></model-select>

                  <div
                    v-if="employeeAdvanceForm.advance_type === null"
                    class="invalid-feedback-custom"
                  >
                    Tipe Kasbon harus di isi.
                  </div>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col sm="6">
                <b-form-group label-for="description" label="Description">
                  <b-form-textarea
                    id="description"
                    :rows="3"
                    :max-rows="6"
                    v-model="$v.employeeAdvanceForm.description.$model"
                    :state="!$v.employeeAdvanceForm.description.$invalid"
                    required
                  ></b-form-textarea>
                  <b-form-invalid-feedback
                    >Deskripsi harus di isi.</b-form-invalid-feedback
                  >
                </b-form-group>
              </b-col>
            </b-row>

            <div class="text-right">
              <b-button type="button" size="sm" variant="danger" @click="back">
                <i class="fa fa-undo"></i> Back </b-button
              >&nbsp;
              <b-button
                type="submit"
                size="sm"
                variant="primary"
                :disabled="$v.employeeAdvanceForm.$invalid"
              >
                <i class="fa fa-save"></i> Save
              </b-button>
            </div>
          </div>

          <div v-else>
            <loading></loading>
          </div>
        </b-form>
      </b-card-body>
    </b-card>

    
    <b-card size="sm" footer-bg-variant="white" footer-border-variant="white">
      <b-tabs>
        <b-tab title="Detail Kasbon" active>
          <employee-advance-item-detail
            :loading-param="loading"
            :advance-id="employeeAdvanceForm.id"
            :advance-detail-item="advanceDetailItem"
            @reload="getAllEmployeeDetail"
          ></employee-advance-item-detail>
        </b-tab>
      </b-tabs>
    </b-card> 
  </div>
</template>


<script>
import axios from "axios";
import globalTable from "../../templates/Table.vue";
import _interfaces from "@/templates/_interfaces.js";
import { required, email } from "vuelidate/lib/validators";
import { ModelSelect } from "vue-search-select";
import loading from "@/templates/Loading.vue";
import EmployeeAdvanceItemDetail from "./tabs/EmployeeAdvanceItemDetail.vue";

export default {
  name: "employee_detail",
  components: {
    globalTable,
    ModelSelect,
    loading,
    EmployeeAdvanceItemDetail
  },
  props: {
    tableDetail: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      authorization: 1,
      listEmployeeAdvanceStatus: [],
      listEmployeeAdvanceType: [],
      listPosition: [],
      listEmployeeHO: [],
      advanceDetailItem: [],
      loading: false,
      employeeAdvanceForm: _interfaces.employee_advance,
    };
  },
  validations: {
    employeeAdvanceForm: {
      title: { required },
      advance_type: { required },
      description: { required },
      request_date: {},
      request_by: {},
      status: {},
      approved_by: {},
    },
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error",
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info",
    },
  },
  methods: {
    init: function (employee_id) {
      this.loading = true;
      this.getAllEmployeeDetail(employee_id);
      this.getDropdown();
    },
    getAllEmployeeDetail: function (employee_id) {
      this.loading = true;
      this.axios
        .get("web/employee_advance/detail/" + employee_id + "/")
        .then((response) => {
          this.employeeAdvanceForm = response.data.data;
          this.advanceDetailItem = response.data.item_detail
        })
        .catch((error) => {
          this.expired(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getDropdown: function () {
      this.axios
        .get("web/dropdown/employee-advance/")
        .then((response) => {
          this.listEmployeeAdvanceStatus = response.data.employee_advance_status;
          this.listEmployeeAdvanceType = response.data.employee_advance_type;
        })
        .catch((error) => {
          this.expired(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getPosition: function (event) {
      this.listPositionEmployee = this.listPosition.filter(
        (x) => x.division_id === event
      );
      this.employeeAdvanceForm.position = null;
    },
    back: function () {
      this.$router.go(-1);
    },
    resetForm: function () {
      for (var a in _interfaces.employee_advance) {
        _interfaces.employee_advance[a] = null;
      }
      this.employeeAdvanceForm = _interfaces.employee_advance;
    },
    editEmployee: function (evt) {
      evt.preventDefault();
      let messages = "Apakah anda ingin mengubah permintaan ini ?";
      if (confirm(messages)) {
        let employee = this.employeeAdvanceForm;
        this.axios
          .put("web/employee_advance/change/", employee)
          .then((response) => {
            if (response.data.status === 2000) {
              this.showInfoNotification({
                title: "Ubah Karyawan",
                message: response.data.message,
              });
            }
          })
          .catch((error) => {
            this.expired(error);
          })
          .finally(() => {
            let route = this.$route.path.split("/");
            this.init(route[4]);
          });
      }
    },
    expired: function (error) {
      if (error.response.status === 401) {
        localStorage.clear();
        this.$router.push({ path: "/login" });
        this.showErrorNotification({
          title: "Token Expired",
          message: "Your session has been expired",
        });
      } else {
        this.showErrorNotification({
          title: "Ubah Karyawan",
          message: error.response.data.message,
        });
      }
    },
  },
  mounted() {
    let route = this.$route.path.split("/");
    this.init(route[4]);
  },
};
</script>